<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-form @submit.prevent="transfer">
        <q-card-section>
          <div class="text-h6">Перенести проекты в категорию</div>
          <div class="text-caption q-mt-sm">Источник: {{ projectType.name }}</div>
        </q-card-section>
        <q-card-section>
          <select-project-type v-model="targetProjectType"/>
          <div v-if="isSameCategory" class="text-negative text-caption q-mt-sm">
            Выберите другую категорию
          </div>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
              :disable="!targetProjectType || isSameCategory"
              :loading="transferring"
              no-caps
              label="Перенести"
              type="submit"
              color="primary"
          />
          <q-btn :disable="transferring" color="primary" label="Отмена" no-caps @click="onDialogCancel"/>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {useDialogPluginComponent, useQuasar} from "quasar";
import SelectProjectType from "./SelectProjectType.vue";
import {ProjectType} from "../models/project";
import {useMigrateProjectType} from "../composables/task";

const props = defineProps<{
  projectType: ProjectType
}>()

defineEmits([
  ...useDialogPluginComponent.emits
])

const $q = useQuasar()
const targetProjectType = ref<number | null>(null)
const transferring = ref(false)
const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

const isSameCategory = computed(() => targetProjectType.value === props.projectType.id)

async function transfer() {
  const targetId = targetProjectType.value
  if (targetId == null || isSameCategory.value) {
    return
  }

  transferring.value = true
  const {data, error} = await useMigrateProjectType(props.projectType.id, targetId)
  transferring.value = false
  if (error.value) {
    return
  }
  const movedCount = data.value?.movedCount ?? 0

  $q.notify({
    type: 'positive',
    message: `Перенесено ${movedCount} проектов`,
    position: 'top-right'
  })
  onDialogOK({movedCount})
}
</script>
